import React, { Component } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import { logoutUser } from "../../actions/authActions";
import { Link, NavLink } from "react-router-dom";

class Sidebar extends Component {
  onLogoutClick = (e) => {
    e.preventDefault();
    this.props.logoutUser();
  };

  render() {
    //const { user } = this.props.auth;
    return (
      <div className="border-right" id="sidebar-wrapper">
        <div className="list-group list-group-flush">
          <NavLink
            to="/dashboard"
            className="list-group-item list-group-item-action"
          >
            Dashboard
          </NavLink>
          {localStorage.getItem("name") === "admin" ? (
            <NavLink
              to="/users"
              className="list-group-item list-group-item-action"
            >
              Admin
            </NavLink>
          ) : (
            <></>
          )}
          <NavLink
            to="/launchpad"
            className="list-group-item list-group-item-action"
          >
            LaunchPad
          </NavLink>
          <NavLink to="/cms" className="list-group-item list-group-item-action">
            Cms
          </NavLink>
          <NavLink
            to="/news"
            className="list-group-item list-group-item-action"
          >
            News
          </NavLink>
          <NavLink
            to="/newsdescription"
            className="list-group-item list-group-item-action"
          >
            News Description
          </NavLink>
          {/* <Link to="/contactus" className="list-group-item list-group-item-action">Contact Us</Link> */}
          <NavLink
            to="/articles"
            className="list-group-item list-group-item-action"
          >
            Latest Articles
          </NavLink>

          <NavLink
            to="/roadmaplist"
            className="list-group-item list-group-item-action"
          >
            Roadmap
          </NavLink>



          <button
            className="list-group-item list-group-item-action"
            onClick={this.onLogoutClick}
          >
            Logout <FontAwesomeIcon icon={faSignOutAlt} />
          </button>
        </div>
      </div>
    );
  }
}

Sidebar.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { logoutUser })(Sidebar);
